/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export function useReceberLeadProposta() {
  const LISTAR_LEAD_DETALHE = `${leadsWebEnviroment}/commom/leads/identificacao/v1`;
  const fetchData = async () => {
    const response = await instance.get(LISTAR_LEAD_DETALHE);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["proposta-vendas-lead"],
    refetchOnWindowFocus: false,
  });
  return query;
}
